var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header bg-white text-center"},[(_vm.headerTitle)?_c('h1',{staticClass:"header-title d-inline-block m-0"},[_vm._v(" "+_vm._s(_vm.headerTitle)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }